let service;

let opt = {
    method: 'post',
    auth: true
  };

let httpFn = {
    defaultSet: function( val ){
        service = val;
        return this;
    }
}

httpFn.$http = (opts) => {
  opts = Object.assign({}, opt, opts);
  return new Promise(function (resolve, reject) {
    service(opts).then(res => {
      if(opts.filter && typeof opts.filter === 'function') {
        // res.data.data => 真正的数据
        if(res.data.data) {
          res.data.data = opts.filter(res.data.data)
        }
      }
      if(res) resolve(res);
    }, res => {
      if(res) reject(res);
    });
  });
}

  
['get', 'post', 'delete', 'put'].forEach(type => {
  httpFn.$http[type] = (opts) => {
    opts.method = type;
    return httpFn.$http(opts);
  }
});

export default httpFn;